/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Video_LockInputs */



/**
* | output |
* | --- |
* | "Toggle video lock on/off" |
*
* @param {Shortcut_Keys_Desc_Toggle_Video_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_video_lock = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Video_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Video_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le verrouillage video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videosperre ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva il blocco video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включение/выключение блокировки видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el bloqueo de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换视频锁定开关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオロックのオン/オフを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो लॉक चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/desativar o bloqueio de vídeo")
	return /** @type {LocalizedString} */ ("Toggle video lock on/off")
});